import { apiCall } from './gqlClient';
const GETPROVIDERWORKOUTPLANS_QUERY = "\n  query getProviderWorkoutPlans($userId: Int) {\n    getProviderWorkoutPlans(userId: $userId)\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tdateCreated\n\t\t\tthumbnailUrl\n\t\t\tenrolled\n\t\t\tarchive\n\t\t\tplanGroupId\n      ...fragments\n    }\n  }";
export const getProviderWorkoutPlansApiCall = async function (_ref) {
  let {
    userId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPROVIDERWORKOUTPLANS_QUERY,
    variables: {
      userId
    },
    fragments
  });
};
const GETPROVIDERARCHIVEDWORKOUTPLANS_QUERY = "\n  query getProviderArchivedWorkoutPlans {\n    getProviderArchivedWorkoutPlans\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tdateCreated\n\t\t\tthumbnailUrl\n\t\t\tenrolled\n\t\t\tarchive\n\t\t\tplanGroupId\n      ...fragments\n    }\n  }";
export const getProviderArchivedWorkoutPlansApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETPROVIDERARCHIVEDWORKOUTPLANS_QUERY,
    variables: {},
    fragments
  });
};
const GETFREEWORKOUTPLANS_QUERY = "\n  query getFreeWorkoutPlans {\n    getFreeWorkoutPlans\n    {\n      id\n\t\t\tproviderId\n\t\t\tuserId\n\t\t\tgroupId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\tcurrentPlanNumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdateCreated\n\t\t\tpersonalPlan\n\t\t\tthumbnailUrl\n\t\t\tenrolled\n\t\t\tarchive\n      ...fragments\n    }\n  }";
export const getFreeWorkoutPlansApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETFREEWORKOUTPLANS_QUERY,
    variables: {},
    fragments
  });
};
const GETWORKOUTPLANDETAILS_QUERY = "\n  query getWorkoutPlanDetails($id: String!) {\n    getWorkoutPlanDetails(id: $id)\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tprice\n\t\t\tpublic\n\t\t\tnumberOfWeeks\n\t\t\timageId\n\t\t\tactive\n\t\t\tdateCreated\n\t\t\tthumbnailUrl\n\t\t\tenrolled\n\t\t\tarchive\n\t\t\tplanGroupId\n      ...fragments\n    }\n  }";
export const getWorkoutPlanDetailsApiCall = async function (_ref2) {
  let {
    id
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETWORKOUTPLANDETAILS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CREATEWORKOUTPLAN_QUERY = "\n  mutation createWorkoutPlan($request: WorkoutPlanInput!) {\n    createWorkoutPlan(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createWorkoutPlanApiCall = async function (_ref3) {
  let {
    request
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEWORKOUTPLAN_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const DUPLICATEWORKOUTPLAN_QUERY = "\n  mutation duplicateWorkoutPlan($id: String!) {\n    duplicateWorkoutPlan(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const duplicateWorkoutPlanApiCall = async function (_ref4) {
  let {
    id
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DUPLICATEWORKOUTPLAN_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const UPDATEWORKOUTPLAN_QUERY = "\n  mutation updateWorkoutPlan($request: WorkoutPlanUpdateInput!) {\n    updateWorkoutPlan(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateWorkoutPlanApiCall = async function (_ref5) {
  let {
    request
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEWORKOUTPLAN_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const ADDWORKOUTTOPLAN_QUERY = "\n  mutation addWorkoutToPlan($workoutPlanId: String!, $workouts: [WorkoutPlanScheduleInput]!) {\n    addWorkoutToPlan(workoutPlanId: $workoutPlanId, workouts: $workouts)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const addWorkoutToPlanApiCall = async function (_ref6) {
  let {
    workoutPlanId,
    workouts
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ADDWORKOUTTOPLAN_QUERY,
    variables: {
      workoutPlanId,
      workouts
    },
    fragments
  });
};
const EDITWORKOUTINPLAN_QUERY = "\n  mutation editWorkoutInPlan($planId: String!, $workouts: [WorkoutPlanScheduleInput]!) {\n    editWorkoutInPlan(planId: $planId, workouts: $workouts)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const editWorkoutInPlanApiCall = async function (_ref7) {
  let {
    planId,
    workouts
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: EDITWORKOUTINPLAN_QUERY,
    variables: {
      planId,
      workouts
    },
    fragments
  });
};
const DELETEWORKOUTINPLAN_QUERY = "\n  mutation deleteWorkoutInPlan($id: String!) {\n    deleteWorkoutInPlan(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteWorkoutInPlanApiCall = async function (_ref8) {
  let {
    id
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEWORKOUTINPLAN_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const RESTOREWORKOUTPLAN_QUERY = "\n  mutation restoreWorkoutPlan($id: String!) {\n    restoreWorkoutPlan(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const restoreWorkoutPlanApiCall = async function (_ref9) {
  let {
    id
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: RESTOREWORKOUTPLAN_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CHANGEWORKOUTPLANSTATUS_QUERY = "\n  mutation changeWorkoutPlanStatus($id: String!, $active: Boolean!) {\n    changeWorkoutPlanStatus(id: $id, active: $active)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const changeWorkoutPlanStatusApiCall = async function (_ref0) {
  let {
    id,
    active
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEWORKOUTPLANSTATUS_QUERY,
    variables: {
      id,
      active
    },
    fragments
  });
};